module.exports = __webpack_public_path__ + "assets/img/quotation.88cff348.svg";